import React from 'react';
import { Col, Row, Typography } from 'antd';
import { CheckCircleOutlined, FileTextOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';

const { Title } = Typography;

const SuccessEdit = () => {
  return (
    <div className="text-center">
      <Row className="mb-4">
        <Col md={12} className="mx-auto">
          <CheckCircleOutlined style={{ fontSize: '56px', color: '#42EDBA' }} className="mb-4" />
          <Title level={2}>Contrato de arriendo modificado</Title>
          <p className="mb-2">Se creo una nueva version del contrato. A continuación se enviará un correo electrónico a los firmantes, para que puedan revisar y validar el nuevo contrato de arriendo.</p>
          <Title level={5}>A continuación</Title>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md={18} lg={14} className="mx-auto position-relative">
          <Row gutter={36}>
            <Col xs={18} md={6} className="mx-auto text-center mb-4">
              <div className="circle-icon circle-purple mb-4">
                <EyeOutlined style={{ fontSize: '32px' }} />
              </div>
              <Title level={5} className="mb-2">Revisar y validar</Title>
              <p className="small">Enviaremos un correo a todos los involucrados para que validen el contrato.</p>
            </Col>
            <Col xs={18} md={6} className="mx-auto text-center mb-4">
              <div className="circle-icon circle-gray mb-4">
                <FileTextOutlined style={{ fontSize: '32px' }} />
              </div>
              <Title level={5} className="mb-2">Firmar</Title>
              <p className="small">Cuando todos validen el contrato, recibirán un correo para que puedan firmar con Clave única o Pin Notarial.</p>
            </Col>
            <Col xs={18} md={6} className="mx-auto text-center mb-4">
              <div className="circle-icon circle-gray mb-4">
                <EditOutlined style={{ fontSize: '32px' }} />
              </div>
              <Title level={5} className="mb-2">Firma del notario</Title>
              <p className="small">El notario recibirá el contrato firmado y lo notarisará.</p>
            </Col>
            <Col xs={18} md={6} className="mx-auto text-center mb-4">
              <div className="circle-icon circle-gray mb-4">
                <CheckCircleOutlined style={{ fontSize: '32px' }} />
              </div>
              <Title level={5} className="mb-2">¡Proceso Finalizado!</Title>
              <p className="small">Con la firma del notario enviaremos el contrato firmado y notariado al correo de todos los firmantes.</p>
            </Col>
          </Row>
          <div className="middle-line"></div>
        </Col>
      </Row>
    </div>
  );
};

export default SuccessEdit;